





























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() authorityType!: string;
  @Prop() authorityData!: any;
  authorityDataList = [];
  @Watch("authorityData", { immediate: false, deep: false })
  authorityDatas(n: any, o: any) {
    this.init();
  }
  @Watch("authorityType", { immediate: false, deep: false })
  authorityTypes(n: any, o: any) {
    if (n == "add") {
      this.list.forEach((a: any) => {
        a.value = 1;
      });
      this.optionChoose();
    }
  }
  list: any = [
    {
      title: "课表数据",
      value: 1,
      radioone: "全部课表",
      radiotwo: "部分课表",
      explain: [
        "（查看并处理门店内所有课表）",
        "（仅可查看并处理教师自己的课表）",
      ],
      disabled: false,
      code: "100",
    },
    {
      title: "学员数据",
      value: 1,
      radioone: "全部学员",
      radiotwo: "部分学员",
      explain: [
        "（查看并处理门店内所有学员）",
        "（仅可查看并处理分配给自己的学员）",
      ],
      disabled: false,
      code: "200",
    },
    {
      title: "班级数据",
      value: 1,
      radioone: "全部班级",
      radiotwo: "部分班级",
      explain: [
        "（查看并处理门店内所有班级）",
        "（仅可查看并处理分配给自己的班级）",
      ],
      disabled: false,
      code: "300",
    },
    {
      title: "点名数据",
      value: 1,
      radioone: "全部记录",
      radiotwo: "部分记录",
      explain: [
        "（查看并处理门店内所有点名课次）",
        "（可查看并处理教师自己的课次）",
      ],
      disabled: false,
      code: "400",
    },
    {
      title: "订单数据",
      value: 1,
      radioone: "全部订单",
      radiotwo: "部分订单",
      explain: [
        "（查看并处理门店内所有订单）",
        "（仅可查看并处理自己操作的订单）",
      ],
      disabled: false,
      code: "500",
    },
    {
      title: "课堂点评",
      value: 1,
      radioone: "全部点评",
      radiotwo: "部分点评",
      explain: ["（查看门店内所有点评）", "（仅可查看并处理自己操作的点评）"],
      disabled: false,
      code: "700", // 按时间传 code
    },
    {
      title: "练习数据",
      value: 1,
      radioone: "全部练习",
      radiotwo: "部分练习",
      explain: [
        "（查看并处理门店内所有练习）",
        "（仅可查看并处理自己操作的练习）",
      ],
      disabled: false,
      code: "600", // 按时间传 code
    },
  ];
  created() {}
  init() {
    const _t = this;
    const list = _t.organize(_t.list, _t.authorityData, _t.authorityType);
    _t.list = list;
  }
  organize(arr: any, oarr: any, type: any) {
    return arr.reduce((t: any, v: any) => {
      oarr.map((a: any) => {
        if (a.code == v.code) {
          v.value = a.is_show;
          if (type == "system") {
            v.disabled = true;
          } else {
            v.disabled = false;
          }
        }
      });
      return t.push(v), t;
    }, []);
  }
  optionChoose() {
    const _t = this;
    const list = _t.list.reduce((t: any, v: any) => {
      const data = {
        code: Number(v.code),
        is_show: v.value,
      };
      return t.push(data), t;
    }, []);
    _t.$emit("optionChoose", list);
  }
}
